import { render, staticRenderFns } from "./vimeo.vue?vue&type=template&id=df424306&scoped=true"
import script from "./vimeo.vue?vue&type=script&lang=js"
export * from "./vimeo.vue?vue&type=script&lang=js"
import style0 from "./vimeo.vue?vue&type=style&index=0&id=df424306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df424306",
  null
  
)

export default component.exports